// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__fUFnj","iconWithCounter":"styles_iconWithCounter__C_zcF","counterForLabel":"styles_counterForLabel__koJxa","counterForIcon":"styles_counterForIcon__FENKr"};